export default {
  error: {
    10: 'Le champ est requis',
    11: 'Le champ doit être un nombre',
    20: 'Les dates de début et de fin sont requises',
    21: 'La date de fin ne doit pas être antérieure à la date de début',
    22: 'La date de réponse souhaitée ne doit pas être postérieure à la date de début',
    23: 'La date de fin doit être postérieure à la date de début',
    30: 'Au moins un type de chambre doit être sélectionné',
    40: "Le numéro de téléphone n'a pas le bon format",
    46: 'Vous devez fournir une date de début et de fin',
    authentication: 'Erreur d\'authentification',
    50: 'Les deux mots de passe doivent être identiques',
    55: 'Le mot de passe actuel est incorrect',
    60: 'Le mot de passe doit contenir au moins 8 caractères',
    70: 'Toutes les chambres doivent être remplies',
    80: 'Veuillez saisir une adresse valide',
    90: 'Au moins un numéro de téléphone est requis',
    100: 'Les chambres pour 2 personnes doivent définir un type de lit',
    110: 'Un compte est déjà lié à cette adresse',
    115: 'Déjà existant',
    120: 'Veuillez saisir un nom de domaine valide',
    130: "Vous n'êtes pas authentifié, veuillez saisir votre email",
    140: 'Veuillez saisir une adresse email',
    150: "Le statut de la réservation ne permet pas d'effectuer l'opération",
    160: "Le fichier n'est pas au format demandé",
    170: 'La fichier excède la taille autorisée',
    180: 'Longueur limite dépassée',
    190: 'Chargement du fichier impossible',
    195: "Le message n'a pu être envoyé",
    200: 'Un lieu favori doit contenir des données géographiques',
    205: 'Le lien que vous avez suivi n\'est pas valide',
    210: 'Un hôtel favori doit posséder un identifiant',
    2500: 'Aucune offre ne répond à vos critères',
    roomTypeError: 'Données non disponibles',
    300: 'Champs bancaires invalides',
    301: 'Date de validité CB invalide',
    302: 'Numéro de CB invalide',
    303: 'Cryptogramme CB invalide',
    304: 'Organisation CB invalide',
    403: 'Accès refusé',
    404: "Cette page n'existe pas",
    500: 'Une erreur est survenue. Veuillez contacter votre agent de réservation.',
    '500back': 'Une erreur est survenue.',
    503: 'Service indisponible, veuillez réessayer plus tard',
    510: "Le fichier n'a pas pu être importé",
    525: 'Le lien que vous avez suivi n\'est pas valide',
    650: 'Vous avez déjà répondu à notre enquête.',
    655: 'Le taux doit être un entier compris entre 0% et 100%',
    700: 'Cet email est déjà utilisé pour un autre hotel',
    750: 'La quantité initiale ne peut être inférieure à la quantité réservée et rétrocédée',
    755: 'La date d\'annulation ne peut être supérieur à la date du contingent',
    1000: "Une erreur est survenue lors de l'import du fichier",
    1001: "Le format du fichier n'est pas accepté",
    1002: 'Les en-têtes du fichier ne correspondent pas. Veuillez prendre exemple sur le modèle',
    1003: 'Société manquante',
    1004: 'Société non correspondante',
    1005: 'Voyageur existant',
    1006: 'Veuillez sélectionner un fichier',
    1007: "Certains champs requis (*) n'ont pas été renseignés",
    1008: 'Certaines valeurs ne sont pas acceptables',
    1009: 'Vous devez être manager pour effectuer cette opération',
    not_available: "L'offre n'est plus disponible",
    error: 'Erreur'
  }
}
